/**
 * Estado GPS compartido (tracker silencioso + UI compacta).
 */
let listeners = new Set();
let snapshot = {
  status: 'off', // off | seeking | ok | denied | unavailable
  lat: null,
  lng: null,
  accuracy: null,
  updatedAt: null,
};

function emit() {
  listeners.forEach((fn) => {
    try {
      fn(snapshot);
    } catch {
      /* ignore */
    }
  });
}

export function getGpsSnapshot() {
  return snapshot;
}

export function setGpsSnapshot(partial) {
  snapshot = { ...snapshot, ...partial };
  emit();
}

export function subscribeGps(listener) {
  listeners.add(listener);
  listener(snapshot);
  return () => listeners.delete(listener);
}
